<template>
  <v-dialog
    :value="deleteUserDialog"
    @input="$emit('setDeleteUserDialog', false)"
    max-width="600px"
  >
    <v-card>
      <v-row class="ml-3 mr-3">
        <v-card-text>
          Deleting account will erase all of your data. This operation cannot be
          undone.To continue, type "DELETE" in the box below:
        </v-card-text>
      </v-row>
      <v-row class="ml-3">
        <v-col cols="6">
          <v-form @submit.prevent>
            <v-text-field
              dense
              v-model="str"
              outlined
              placeholder="DELETE"
              name="delete"
            ></v-text-field>
          </v-form>
        </v-col>
        <v-col v-if="!deleting" cols="4">
          <v-btn
            color="error"
            class="text-none"
            :disabled="str !== 'DELETE'"
            @click="execDelete"
          >
            <span>Delete my account</span>
          </v-btn>
        </v-col>
        <v-col v-else cols="4">
          <v-progress-circular
            class="ml-3"
            indeterminate
            color="primary"
          ></v-progress-circular>
        </v-col>
      </v-row>
      <v-row dense>
        <v-btn
          color="error"
          class="text-none ml-4 mb-3"
          text
          @click="$emit('setDeleteUserDialog', false)"
        >
          <span>Close</span>
        </v-btn>
      </v-row>
    </v-card>
  </v-dialog>
</template>

<script>
import {AmplifyEventBus} from 'aws-amplify-vue'
import {Auth} from 'aws-amplify'

export default {
  data: () => ({
    str: null,
    deleting: false,
  }),
  props: {
    deleteUserDialog: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    async execDelete() {
      this.deleting = true
      const result = await this.deleteAccount()
      if (!result) {
        this.deleting = false
        return
      }
      try {
        await Auth.signOut()
        AmplifyEventBus.$emit('authState', 'withdraw')
      } catch (e) {
        // Do nothing.
      }
    },
  },
  mounted() {},
}
</script>
